import { styled } from '@mui/material/styles';
import { Box, CircularProgress, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { MedicationListItem } from '../../../../../store/hubOwner/types';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMedicationImage } from '../../../../../store/customers/actionCreators';
import { borderGrey, dimGrey, lightBlack } from '../../../../../mainTheme';

interface DescriptionDetailsProps {
  rowData: MedicationListItem | null;
}

const DetailLabel = styled(Typography)({
  color: lightBlack,
  fontWeight: 700,
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '0.2px',
  marginBottom: '4px',
});

const DetailValue = styled(Typography)({
  color: dimGrey,
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '0.2px',
});

const DescriptionRow = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '16px',
});

const ExampleImage = styled('img')({
  width: '100%',
  maxHeight: '300px',
  height: 'auto',
  borderRadius: '4px',
  border: `1px solid ${borderGrey}`,
});

export const MedicationDescriptionDetails: React.FC<
  DescriptionDetailsProps
> = ({ rowData }) => {
  const dispatch = useDispatch();

  const { medicationImage, medicationImageLoading } = useSelector(
    (state: any) => state.customers,
  );

  useEffect(() => {
    if (rowData?.national_drug_code)
      dispatch(fetchMedicationImage(Number(rowData.national_drug_code)));
  }, [rowData]);

  return (
    <Box sx={{ py: 2 }}>
      <DescriptionRow>
        <Box sx={{ flex: 1, mr: 2 }}>
          <DetailLabel>Description</DetailLabel>
          <DetailValue>{rowData?.name || ' N/A'}</DetailValue>
        </Box>
        <Box sx={{ flex: 1 }} display="none">
          <DetailLabel>Imprint</DetailLabel>
          {/* Current we dont have data for Imprint on the system */}
          <DetailValue>N/A</DetailValue>
        </Box>
        <Box sx={{ flex: 1, mr: 2 }}>
          <DetailLabel>Pouched</DetailLabel>
          <DetailValue>{rowData?.medication_type || 'N/A'}</DetailValue>
        </Box>
      </DescriptionRow>

      <DetailLabel>Example image</DetailLabel>
      {medicationImageLoading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight={200}
        >
          <CircularProgress />
        </Box>
      ) : medicationImage ? (
        <ExampleImage src={medicationImage} alt="Sample medication" />
      ) : (
        <Box>
          <DetailValue sx={{ textAlign: 'center', width: '100%' }}>
            No data
          </DetailValue>
        </Box>
      )}
    </Box>
  );
};
